module.exports = __webpack_public_path__ + "static/media/dollar.ebbd0295.png";